import { generateUnOrderedList, getCircleTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const FigureDesc6 = {
    title: "Figure 6: Journey of the Accused Persons through the Court Complex.",
    para1: <>
        <p><span><b>Orientation of the figure:</b> </span>
            This figure uses a winding process flow to depict the typical passage of the accused persons through the Court Complex and the various areas and amenities with which they interact. At each space or amenity shown, specific icons have been depicted which are described below. The key for the icons, divided in accordance with the five principles used in the Handbook, is shown at the top right corner of the figure. At the right side of the figure, the needs of accused persons in moving through the Court Complex have been detailed, which is additionally reproduced as part of the main text of the Handbook.
        </p>
        <p>
            The typical passage of the accused persons is described below from the start of the journey to the end, as depicted in the process flow shown in each row of the figure.
        </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    <>
                        Row 1 (described from left to right):
                        {getCircleTypeListItem([
                            "At the start, the accused persons encounter a gated entrance (01). The icons here represent amenities which must be adaptable and comfortable.",

                            "There is provision for a security cabin (02) next to the entrance. Signage and seating facilities have been provided next to the security cabin. The icon here represents security which must be comfortable.",

                            "After going through the entrance, there is provision for parking (03) of the prison van. The icon here represents parking which must be accessible.",

                            "While entering the Court Complex building, the accused persons pass through another security checkpoint (04). At the security check, the facilities include a baggage scanner facility along with security personnel. The icon here represents operations which must be efficient. ",
                        ])}
                    </>,
                    <>
                        Row 2 (described from right to left):
                        {getCircleTypeListItem([
                            "Upon entering the Court Complex premises, the accused persons are taken to the judicial lock-up (05). The icon here represents amenities which must be comfortable. ",

                            "The accused persons are taken through a dedicated lift lobby (06). The icons here represent operations which must be futuristic and efficient. ",

                            "The accused persons are taken to a dedicated accused waiting room (07). The icon here represents amenities which must be comfortable. ",

                        ])}
                    </>,
                    <>
                        Row 3 (described from left to right):
                        {getCircleTypeListItem([
                            "The accused persons are taken to the Courtroom (08). The icons here represent accessibility, efficient operations, and comfortable amenities.",

                            "The accused persons can then visit the Visiting Room (09). The icons here represent accessibility, efficient operations, and comfortable amenities. ",
                        ])}
                    </>,
                    <>
                        Row 4 (described from right to left):
                        {getCircleTypeListItem([
                            "When exiting the premises, the accused persons are taken in a prison van past the exit security checkpoint (10). The icons here represent operations which must be efficient and security which must be comfortable.",

                            "The accused persons then exit the Court Complex (11). The icons here represent amenities which must be adaptable and comfortable.",
                        ])}
                    </>,
                ])}
            </div>
        </p>
    </>,
}

export const FigureDesc7 = {
    title: "Figure 7: Journey of the Advocates through the Court Complex.",
    para1: <>
        <p>
            <span><b>Orientation of the figure: </b> </span>
            This figure uses a winding process flow to depict the typical passage of advocates through the Court Complex and the various areas and amenities with which they interact. At each space or amenity shown, specific icons have been depicted which are described below. The key for the icons, divided in accordance with the five principles used in the Handbook, is shown at the top right corner of the figure. At the right side of the figure, the needs of advocates in moving through the Court Complex have been detailed, which is additionally reproduced as part of the main text of the Handbook.
        </p>
        <p>
            The typical passage of the advocates is described below from the start of the journey to the end, as depicted in the process flow shown in each row of the figure.
        </p>
        <p>
            <span><b>Description:</b> </span>
            <div className="figure_desc">
            {generateUnOrderedList([
                <>
                    Row 1 (described from left to right):
                    {getCircleTypeListItem([
                        "At the start, the advocates encounter a gated entrance (01). The icons here represent amenities which must be efficient and comfortable.",

                        "There is provision for a security cabin (02) next to the entrance. Signage and seating facilities have been provided next to the security cabin. The icon here represents security which must be comfortable. ",

                        "Next to the security provisions, an ATM facility (03) is provided. The icon here represents amenities which must be comfortable. ",

                        "There is provision for parking (04) for the advocates’ vehicles. The icon here represents parking which must be accessible.",

                        "While entering the Court Complex building, the advocates pass through another security checkpoint (05). At the security check, the facilities include a baggage scanner facility along with security personnel. The icon here represents operations which must be efficient."
                    ])}
                </>,

                <>
                    Row 2 (described from right to left):
                    {getCircleTypeListItem([
                        "Upon entering the Court Complex premises, the advocates enter the lift lobby (06) to access other spaces in the Court Complex. ",

                        "The advocates visit the Filing Counter (07) to file fresh cases. The icons here represent operations which must be adaptable and futuristic. ",

                        "The advocates make use of the facilities at the Bar Association Room (08). The icons here represent operations which must be adaptable and futuristic, a comfortable indoor environment, and comfortable security.",

                        "The advocates make use of Xerox facilities (09) for their case files. The icon here represents operations which must be adaptable. ",

                        "The advocates make use of washroom facilities (10). The icon here represents amenities which must be accessible.",

                        "The advocates interact with the public-facing Administrative offices (11) in the course of carrying out their functions. The icons here represent operations which must be futuristic and efficient. ",
                    ])}
                </>,

                <>
                    Row 3 (described from left to right):
                    {getCircleTypeListItem([
                        "Within the Court Complex, the advocates make use of Case Display screens (12) for real-time updates about case status in Courtrooms. The icons here represent operations which must be adaptable and accessible.",

                        "The advocates interact within the Courtrooms (13) when their cases are called for hearing before the Judge. The icons here represent accessibility, efficient operations and adaptable amenities.",

                        "The advocates also make use of the Lounge facilities (14). The icons here represent accessibility and comfortable amenities.",

                    ])}
                </>,

                <>
                    Row 4  (described from right to left):
                    {getCircleTypeListItem([
                        "The advocates make use of Canteen facilities (15). The icons here represent accessibility and comfortable amenities. ",

                        "Upon exiting the Court Complex premises at the end of the day, the advocates again encounter the security cabin (16) at the exit. The icons here represent efficient operations and comfortable security. ",

                        "The advocates exit the Court Complex through the exit gate (17). The icons here represent efficient and comfortable amenities. ",
                    ])}
                </>,
            ])}
            </div>
        </p>
    </>,
}

export const FigureDesc8 = {
    title: "Figure 8: Journey of the Judicial Officers through the Court Complex.",
    para1: <>
        <p><span><b>Orientation of the figure: </b> </span>
            This figure uses a winding process flow to depict the typical passage of Judicial Officers through the Court Complex and the various areas and amenities with which they interact. At each space or amenity shown, specific icons have been depicted which are described below. The key for the icons, divided in accordance with the five principles used in the Handbook, is shown at the top right corner of the figure. At the right side of the figure, the needs of Judicial Officers in moving through the Court Complex have been detailed, which is additionally reproduced as part of the main text of the Handbook.
        </p>
        <p>
            The typical passage of the Judicial Officers is described below from the start of the journey to the end, as depicted in the process flow shown in each row of the figure.
        </p>
        <p>
            <span><b>Description:</b> </span>
            <div className="figure_desc">
            {generateUnOrderedList([
                <>
                    Row 1 (described from left to right):
                    {getCircleTypeListItem([
                        "At the start, the Judicial Officers encounter a gated entrance (01). The icons here represent amenities which must be efficient and comfortable.",

                        "There is provision for a security cabin (02) next to the entrance. Signage and seating facilities have been provided next to the security cabin. The icon here represents security which must be comfortable. ",

                        "After going through the entrance, there is provision for parking (03) for Judges. The icon here represents parking which must be accessible.",

                        "While entering the Court Complex building, the Judicial Officers pass through a security checkpoint (04). At the security check, the facilities include a baggage scanner facility along with security personnel. The icon here represents operations which must be efficient.",

                    ])}
                </>,

                <>
                    Row 2 (described from right to left):
                    {getCircleTypeListItem([
                        "Upon entering the Court Complex premises, the Judicial Officers navigate through the Court Complex building by way of the designated Judges’ Corridors (05).",

                        "The Judicial Officers reach the Judge’s Chamber (06). The icons here represent accessibility, comfortable seating, and efficient storage. ",

                        "The Judicial Officers spend their time in the Courtroom (07). The icons here represent accessibility, efficient amenities, and a comfortable indoor environment.",

                    ])}
                </>,

                <>
                    Row 3 (described from left to right):
                    {getCircleTypeListItem([
                        "The Judicial Officers make use of the Lounge facilities (08). The icons here represent efficient operations and comfortable amenities. ",

                        "From time to time, the Judicial Officers make use of the Conference Room facilities (09) to conduct meetings and attend conferences/training programs. The icons here represent operations which must be adaptable and futuristic.",

                    ])}
                </>,

                <>
                    Row 4  (described from right to left):
                    {getCircleTypeListItem([
                        "Upon exiting the Court Complex premises, the Judicial Officers again encounter the security cabin (10) at the exit. The icons here represent efficient operations and comfortable security. ",

                        "The Judicial Officers exit the Court Complex through the exit gate (11). The icons here represent efficient and comfortable amenities. ",

                    ])}
                </>,


            ])}
            </div>
        </p>
    </>,
}

export const FigureDesc9 = {
    title: "Figure 9: Journey of the Judicial Staff through the Court Complex.",
    para1: <>
        <p>
            <span><b>Orientation of the figure:</b> </span>
            This figure uses a winding process flow to depict the typical passage of the Judicial Staff through the Court Complex and the various areas and amenities with which they interact. Rows 2 and 3 depict simultaneous movement of Staff, depending on their role and designation, to their specific offices.
        </p>
        <p>At each space or amenity shown, specific icons have been depicted which are described below. The key for the icons, divided in accordance with the five principles used in the Handbook, is shown at the top right corner of the figure. At the right side of the figure, the needs of Judicial Staff in moving through the Court Complex have been detailed, which is additionally reproduced as part of the main text of the Handbook. </p>
        <p>
            The typical passage of the Judicial Staff is described below from the start of the journey to the end, as depicted in the process flow shown in each row of the figure.
        </p>
        <p>
            <span><b>Description:</b></span>
            <div className="figure_desc">
            {generateUnOrderedList([
                <>
                    Row 1 (described from left to right):
                    {getCircleTypeListItem([
                        "At the start, the Judicial Staff encounter a gated entrance (01). The icons here represent amenities which must be efficient and comfortable.",

                        "There is provision for a security cabin (02) next to the entrance. Signage and seating facilities have been provided next to the security cabin. The icons here represent efficient operations and comfortable security. ",

                        "Next to the security provisions, an ATM facility (03) is provided. The icon here represents amenities which must be efficient.",

                        "There is provision for parking (04) for the vehicles of the Judicial Staff. The icon here represents parking which must be accessible. ",

                        "While entering the Court Complex building, the Judicial Staff pass through another security checkpoint (05). At the security check, the facilities include a baggage scanner facility along with security personnel. The icon here represents efficient operations and comfortable security.",
                    ])}
                </>,

                "Upon entering the Court Complex premises, the Judicial Staff proceed to their offices. These offices might carry out predominantly private-facing functions or predominantly public-facing functions. Judicial Staff may also carry out their duties at other locations, such as the Courtroom, Judge’s Chamber etc. Therefore, rows 2 and 3 depict simultaneous options depending on the particular Staff’s role and designation. ",

                <>
                    Row 2 (described from right to left):
                    {getCircleTypeListItem([
                        "The private-facing offices may be either single-person offices (06) or multi-person offices (07). The icons at the single-person offices represent accessibility, efficient amenities and storage, and comfortable storage. The icons at the multi-person offices represent adaptable and futuristic operations, a comfortable indoor environment and comfortable seating. ",

                        "The Judicial Staff make use of Xerox facilities (08). The icon here represents accessibility and adaptable amenities. ",

                        "The Judicial Staff are also present at public-facing administrative offices (09). The icons here represent operations which must be futuristic and efficient.",
                    ])}
                </>,

                <>
                    Row 3 (described from right to left):
                    {getCircleTypeListItem([
                        "The Judicial Staff make use of the Washroom facilities (10). The icons here represent accessibility and efficient amenities.",

                        "The Judicial Staff also make use of the Lounge facilities for staff (11). The icons here represent accessibility and comfortable amenities.",

                        "The Judicial Staff may be required to work at the Courtrooms (12). The icons here represent adaptable operations, futuristic storage, accessibility and efficient amenities.",

                        "The Judicial Staff may also be required to work at the Judge’s Chamber (13). The icon here represents accessibility.",

                    ])}
                </>,

                <>
                    Row 4  (described from right to left):
                    {getCircleTypeListItem([
                        "The Judicial Staff make use of Canteen facilities (14). The icons here represent accessibility and comfortable amenities. ",

                        "Upon exiting the Court Complex premises at the end of the day, the Judicial Staff again encounter the security cabin (15) at the exit. The icons here represent efficient operations and comfortable security. ",

                        "The Judicial Staff exit the Court Complex through the exit gate (16). The icons here represent efficient and comfortable amenities. ",

                    ])}
                </>,
            ])}
            </div>
        </p>

    </>
}

export const FigureDesc10 = {
    title: "Figure 10: Journey of the Litigants through the Court Complex.",
    para1: <>
        <p><span><b>Orientation of the figure: </b></span>
            This figure uses a winding process flow to depict the typical passage of litigants through the Court Complex and the various areas and amenities with which they interact. At each space or amenity shown, specific icons have been depicted which are described below. The key for the icons, divided in accordance with the five principles used in the Handbook, is shown at the top right corner of the figure. At the right side of the figure, the needs of litigants in moving through the Court Complex have been detailed, which is additionally reproduced as part of the main text of the Handbook.
        </p>
        <p>
            The typical passage of the litigants is described below from the start of the journey to the end, as depicted in the process flow shown in each row of the figure.
        </p>
        <p>
            <span><b>Description:</b> </span>
            <div className="figure_desc">
            {generateUnOrderedList([
                <>
                    Row 1 (described from left to right):
                    {getCircleTypeListItem([
                        "At the start, the litigants encounter a gated entrance (01). The icons here represent accessible navigation.",

                        "There is provision for a security cabin (02) next to the entrance. Signage and seating facilities have been provided next to the security cabin. The icon here represents security which must be comfortable.",

                        "Next to the security provisions, an ATM facility (03) is provided. The icon here represents amenities which must be comfortable. ",

                        "There is provision for parking (04). The icon here represents parking which must be accessible. ",

                        "While entering the Court Complex building, the litigants pass through another security checkpoint (05). At the security check, the facilities include a baggage scanner facility along with security personnel. The icon here represents operations which must be efficient. "

                    ])}
                </>,

                <>
                    Row 2 (described from right to left):
                    {getCircleTypeListItem([
                        "Upon entering the Court Complex premises, the litigants enter the waiting room (06) to wait for their cases to be called. The icons here represent accessibility, efficient operations, and comfortable seating.",

                        "The litigants may visit the Filing Counter (07) along with their advocates to file fresh cases. The icons here represent operations which must be adaptable and futuristic. ",

                        "The litigants make use of Xerox facilities (08) for their case files. The icon here represents operations which must be adaptable.",

                        "The litigants interact with the public-facing Administrative offices (09) wherever needed. The icons here represent operations which must be futuristic and efficient.",

                    ])}
                </>,

                <>
                    Row 3 (described from left to right):
                    {getCircleTypeListItem([
                        "The litigants make use of Washroom facilities (10). The icon here represents accessibility. ",

                        "Within the Court Complex, the litigants make use of Case Display screens (11) for real-time updates about case status in the Courtrooms. The icons here represent accessibility and adaptable operations.",

                        "The litigants interact within the Courtrooms (12) when their cases are called for hearing before the Judge. The icons here represent accessibility, futuristic operations and efficient amenities.",

                    ])}
                </>,

                <>
                    Row 4  (described from right to left):
                    {getCircleTypeListItem([
                        "The litigants make use of Canteen facilities (13). The icons here represent accessibility and comfortable amenities.",

                        "Upon exiting the Court Complex premises, the litigants again encounter the security cabin (14) at the exit. The icons here represent efficient operations and comfortable security. ",

                        "The litigants exit the Court Complex through the exit gate (15). The icons here represent efficient and comfortable amenities. ",
                    ])}
                </>,
            ])}
            </div>
        </p>
    </>,
}

export const FigureDesc11 = {
    title: "Figure 11: Journey of the Vulnerable Witnesses through the Court Complex",
    para1: <>
        <p><span><b>Orientation of the figure:</b> </span>
            This figure uses a winding process flow to depict the typical passage of Vulnerable Witnesses through the Court Complex and the various areas and amenities with which they interact. At each space or amenity shown, specific icons have been depicted which are described below. The key for the icons, divided in accordance with the five principles used in the Handbook, is shown at the top right corner of the figure. At the right side of the figure, the needs of Vulnerable Witnesses in moving through the Court Complex have been detailed, which is additionally reproduced as part of the main text of the Handbook.
        </p>
        <p>
            The typical passage of the Vulnerable Witnesses is described below from the start of the journey to the end, as depicted in the process flow shown in each row of the figure.
        </p>
        <p>
            <span><b>Description:</b></span>
            <div className="figure_desc">
            {generateUnOrderedList([
                <>
                    Row 1 (described from left to right):
                    {getCircleTypeListItem([
                        "At the start, the Vulnerable Witnesses encounter a gated entrance (01). The icons here represent amenities which must be efficient and comfortable.",

                        "There is provision for a security cabin (02) next to the entrance. Signage and seating facilities have been provided next to the security cabin. The icon here represents security which must be comfortable. ",

                        "There is provision for segregated parking (03) for Vulnerable Witnesses. The icon here represents parking which must be accessible.",

                        "While entering the Court Complex building, the Vulnerable Witnesses pass through another security checkpoint (04). At the security check, the facilities include a baggage scanner facility along with security personnel. The icon here represents operations which must be efficient. ",
                    ])}
                </>,

                <>
                    Row 2 (described from right to left):
                    {getCircleTypeListItem([
                        "Upon entering the Court Complex premises, the Vulnerable Witnesses enter the separate lift lobby (05) to access other spaces in the Court Complex. ",

                        "The Vulnerable Witnesses proceed to the separate waiting rooms (06). These rooms are self-contained, and possess facilities such as attached washrooms, pantry area etc. The icons here represent accessibility and comfortable seating. ",
                    ])}
                </>,

                <>
                    Row 3 (described from left to right):
                    {getCircleTypeListItem([
                        "The Vulnerable Witnesses make use of Washroom facilities (07). The icon here represents accessibility. ",

                        "The Vulnerable Witnesses are taken to a separate Deposition Room (08) to ensure safety, privacy and comfort while recording testimony. The icons here represent futuristic operations, accessibility, and adaptable amenities.",

                        "The Vulnerable Witnesses make use of separate Pantry facilities (09). The icons here represent adaptable and accessible operations. ",

                        "The Vulnerable Witnesses may visit the Psychologist’s Room (10) wherever available, depending on their requirements. The icon here represents comfortable amenities. ",
                    ])}
                </>,

                <>
                    Row 4  (described from right to left):
                    {getCircleTypeListItem([
                        "Upon exiting the Court Complex premises, the Vulnerable Witnesses again encounter the security cabin (11) at the exit. The icons here represent efficient operations and comfortable security. ",

                        "The Vulnerable Witnesses exit the Court Complex through the exit gate (17). The icons here represent efficient and comfortable amenities. ",
                    ])}
                </>,
            ])}
            </div>
        </p>
    </>,
}

